import React, { useEffect, useState } from "react";
import { Loader2, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../../lib/api";

export default function AuditLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/audit-log?limit=500").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div className="p-8 lg:p-10" data-testid="page-audit-log">
      <Link to="/admin/users" className="text-sm text-slate-500 hover:text-slate-900 flex items-center gap-2 mb-4"><ArrowLeft className="w-4 h-4" /> Users</Link>
      <div className="mb-8">
        <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">Compliance</p>
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-slate-900">Audit log</h1>
        <p className="text-slate-500 mt-2">Append-only log of every user, enquiry, quote and staff record change — supports ISO 9001 / ISO 27001 evidence.</p>
      </div>
      {items === null ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
      ) : (
        <div className="bg-white border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500 bg-slate-50">
                <th className="px-6 py-3 font-medium">When</th>
                <th className="px-6 py-3 font-medium">User</th>
                <th className="px-6 py-3 font-medium">Action</th>
                <th className="px-6 py-3 font-medium">Resource</th>
                <th className="px-6 py-3 font-medium">Note</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a, i) => (
                <tr key={a.id || i} className="border-t border-slate-100" data-testid="audit-row">
                  <td className="px-6 py-3 text-xs text-slate-500 whitespace-nowrap">{new Date(a.at).toLocaleString()}</td>
                  <td className="px-6 py-3">{a.by_user_name}<br/><span className="text-xs text-slate-500">{a.by_user_email}</span></td>
                  <td className="px-6 py-3 font-mono text-xs">{a.action}</td>
                  <td className="px-6 py-3 text-xs">{a.resource_type}<br/><span className="text-slate-400">{a.resource_id?.slice(0, 8)}</span></td>
                  <td className="px-6 py-3 text-xs text-slate-600 max-w-md truncate" title={a.note}>{a.note || (a.after ? JSON.stringify(a.after).slice(0, 160) : "—")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
